import "whatwg-fetch";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ set AFTER render, on body
document.body.style.setProperty(
  "background-image",
  `linear-gradient(180deg, rgba(9, 8, 10, 0.72), rgba(9, 8, 10, 0.92)),url(/img/background.png)`
);

reportWebVitals();